import { TRM_CONSTANTS } from '../constants/trmConstants';

/**
 * getStatusForScenario
 * @param statusId
 * @returns {string}
 */
export const getStatusForScenario = (statusId) => {
  if (statusId === 'InQueue') {
    return TRM_CONSTANTS.YET_TO_START;
  }
  if (statusId === 'InProgress') {
    return TRM_CONSTANTS.IN_PROGRESS;
  }
  if (statusId === 'Completed') {
    return TRM_CONSTANTS.COMPLETED;
  }
  if (statusId === 'Failed') {
    return TRM_CONSTANTS.FAILED;
  } else {
    return TRM_CONSTANTS.YET_TO_START;
  }
};

/**
 * getStrForChampion
 * @param strStatus
 * @returns {string}
 */
export const getStrForChampion = (strStatus) => strStatus;
